import { Spinner } from 'src/components';
import useFetchData from 'src/hooks/useFetchData';
import { AnalyticsTable } from './analytics-table';

type ClosedApplications = {
  name: string;
  data: [string, number, number][];
};

export const Analytics = () => {
  const { data, loading } = useFetchData<ClosedApplications[]>({
    url: `/reference-checks/stats/ops-closed-applications/`,
  });

  return (
    <div>
      {loading || !data ? (
        <div className="w-full h-screen flex items-center justify-center">
          <Spinner />
        </div>
      ) : (
        <div className="m-6 w-[50%]">
          <AnalyticsTable data={data[0].data} />
        </div>
      )}
    </div>
  );
};
